import React from 'react';
import './InputCheckbox.css';

export function InputCheckbox({name, checked, disabled, onChange, title = ''}) {

  return <label className="square-checkbox">
    <input type="checkbox" name={name} checked={checked} className="square-checkbox__input" disabled={disabled} onChange={(e) => onChange(name, e.target.checked)} />
    <span className="square-checkbox__icon"></span>
    {title !== '' && <span className="square-checkbox__title">{title}</span>}
  </label>;
}
